var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__heading d-flex"},[_vm._t("back"),_vm._t("slash"),_c('div',[_c('h1',{staticClass:"primary--text"},[_vm._t("heading")],2),_vm._t("subHeading")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }